export function systemsQuerySqlCopyTooltip(
  hasCapturedQueryRun: boolean,
  captureEnabled: boolean
): string | undefined {
  if (hasCapturedQueryRun) return undefined;
  if (captureEnabled) return 'No systems query has run yet with capture on';
  return 'Turn on Capture Systems Query SQL, then run a systems query';
}
